import React, { useState, useEffect, useCallback } from "react";
import { Navbar, Nav, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
    PersonCircle,
    Clipboard,
    PencilSquare,
    InfoCircle,
    BoxArrowInRight,
    PersonPlus,
} from "react-bootstrap-icons";
import { jwtDecode } from "jwt-decode";
import logo from "../../assets/Logo-Thinail.png";
import "./header.css";

// Định nghĩa các hàm tiện ích bên ngoài component
const isAuthenticated = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            const decodedToken = jwtDecode(accessToken);
            return decodedToken.exp > Date.now() / 1000;
        } catch {
            localStorage.removeItem("accessToken");
        }
    }

    const token = localStorage.getItem("token");
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.exp > Date.now() / 1000;
        } catch {
            localStorage.removeItem("token");
        }
    }

    return !!localStorage.getItem("user");
};

const getUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
        return {};
    }
};

const Header = () => {
    // eslint-disable-next-line
    //const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [currentUser, setCurrentUser] = useState({});

    // Bây giờ checkAuthStatus sẽ được ghi nhớ và không tạo ra vòng lặp vô hạn
    const checkAuthStatus = useCallback(() => {
        const authenticated = isAuthenticated();
        setIsLoggedIn(authenticated);
        if (authenticated) {
            setCurrentUser(getUser());
        } else {
            setCurrentUser({});
        }
    }, []);

    useEffect(() => {
        // Kiểm tra trạng thái đăng nhập khi component mount
        checkAuthStatus();

        // const handleResize = () => {
        //     setIsMobile(window.innerWidth < 992);
        // };

        // Thêm event listener để lắng nghe sự thay đổi trong localStorage
        const handleStorageChange = () => {
            checkAuthStatus();
        };

        // Thêm event listener cho sự kiện tùy chỉnh từ Login.js
        const handleAuthChange = () => {
            checkAuthStatus();
        };

        //window.addEventListener('resize', handleResize);
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('auth_state_changed', handleAuthChange);
        
        // Để đảm bảo Header cập nhật khi đăng nhập xong và chuyển trang
        const checkAuthInterval = setInterval(checkAuthStatus, 1000);

        return () => {
           // window.removeEventListener('resize', handleResize);
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('auth_state_changed', handleAuthChange);
            clearInterval(checkAuthInterval);
        };
    }, [checkAuthStatus]);

    return (
        <Navbar expand="lg" className="custom-navbar py-2">
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                    <img
                        src={logo}
                        alt="Thinail Logo"
                        height="40"
                        className="d-inline-block align-top me-2 logo"
                    />
                    <span className="brand-text">Thi Nail</span>
                </Navbar.Brand>
                
                <Nav className="ms-auto align-items-center">
                    {isLoggedIn ? (
                        <>
                            <Nav.Link as={Link} to="/about" className="custom-link mx-2" title="Liên hệ">
                                <InfoCircle className="mobile-icon" size={22} />
                                <span className="nav-text">Liên Hệ</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to="/quizzes" className="custom-link mx-2" title="Đề thi">
                                <Clipboard className="mobile-icon" size={22} />
                                <span className="nav-text">Đề Thi</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to="/exam" className="custom-link mx-2" title="Thi thử">
                                <PencilSquare className="mobile-icon" size={22} />
                                <span className="nav-text">Thi Thử</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to="/profile" className="custom-link mx-2 d-flex align-items-center" title="Tài khoản">
                                {currentUser?.avatar ? (
                                    <Image
                                        src={currentUser.avatar}
                                        alt="avatar"
                                        roundedCircle
                                        height="50"
                                        width="50"
                                        className="mobile-icon"
                                    />
                                ) : (
                                    <PersonCircle className="mobile-icon" size={22} />
                                )}
                                <span className="nav-text">{currentUser?.firstName || "Tài khoản"}</span>
                            </Nav.Link>

                        </>
                    ) : (
                        <>
                            <Nav.Link as={Link} to="/about" className="custom-link mx-2" title="Liên hệ">
                                <InfoCircle className="mobile-icon" size={22} />
                                <span className="nav-text">Liên Hệ</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to="/login" className="custom-link mx-2" title="Đăng nhập">
                                <BoxArrowInRight className="mobile-icon" size={22} />
                                <span className="nav-text">Đăng nhập</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to="/register" className="custom-link mx-2" title="Đăng ký">
                                <PersonPlus className="mobile-icon" size={22} />
                                <span className="nav-text">Đăng ký</span>
                            </Nav.Link>
                        </>
                    )}
                </Nav>
            </Container>
        </Navbar>
    );
};

export default Header;